import type { IconData } from '@stacksjs/iconify-core'

export const circleClockSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M24 1.5C11.574 1.5 1.5 11.574 1.5 24S11.574 46.5 24 46.5S46.5 36.426 46.5 24S36.426 1.5 24 1.5M39 24c0 8.284-6.716 15-15 15S9 32.284 9 24S15.716 9 24 9s15 6.716 15 15m-12.5-9a2.5 2.5 0 0 0-5 0v9a2.5 2.5 0 0 0 .732 1.768l6 6a2.5 2.5 0 0 0 3.536-3.536L26.5 22.965z\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default circleClockSolid
